"use strict"
exports.__esModule = true;
exports.HeadphonesIconConfig = {
  name: 'HeadphonesIcon',
  height: 512,
  width: 512,
  svgPath: 'M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z',
  yOffset: 0,
  xOffset: 0,
};
exports.HeadphonesIcon = require('../createIcon').createIcon(exports.HeadphonesIconConfig);
exports["default"] = exports.HeadphonesIcon;